var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CTabs',{staticClass:"nav-tabs-boxed",attrs:{"variant":"tabs"}},[_c('CTab',{attrs:{"title":_vm.descPlural}},[_c('CartaoCredito')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }